import * as React from "react"
import Svg, { SvgProps, Path } from "react-native-svg"
const LoveIcon = (props: SvgProps) => (
  <Svg
    
    width={16}
    height={16}
    fill="none"
    {...props}
  >
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.9}
      d="M8.065 15c1.863-.804 5.822-3.507 6.75-7.883 1.16-5.47-3.375-7.507-6.75-5.148-3.375 2.36-1.53 9.33 2.426 11.315"
    />
    <Path
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={0.9}
      d="M8.074 15c-1.9-.804-5.938-3.507-6.885-7.883C.006 1.647 4.632-.39 8.074 1.97c3.443 2.36 1.56 9.33-2.474 11.315"
    />
  </Svg>
)
export default LoveIcon
